import React from "react";
import { ReleaseNotes } from "@amsanalytics/react-shared-library";
import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Tooltip } from "@mui/material";

export interface ReleaseNotesBannerProps {
  releaseNotes: ReleaseNotes[];
  onDismiss: (releaseNotesId: string) => void;
}

// Release notes component. Renders a list of release notes and their html content.
export default function ReleaseNotesBanner(props: ReleaseNotesBannerProps) {
  return (
    <div style={{ width: '100%', backgroundColor: '#ffef5f', height: '33px', overflowY: 'auto' }}>
      {props.releaseNotes.map((releaseNote: ReleaseNotes, index: number) => (
        <div key={index} style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', marginLeft: '10px' }}>
          <div dangerouslySetInnerHTML={{ __html: releaseNote.summary }} />
          <Tooltip title='Dismiss this note'>
            <IconButton onClick={() => props.onDismiss(releaseNote.id)} size="small">
              <CloseIcon style={{ color: '#000000', fontSize: '22px' }} />
            </IconButton>
          </Tooltip>
        </div>
      ))}
    </div>
  );
}